import React, { useRef } from 'react';

import { useCurrentUser } from 'Auth';

import { useLoadAffiliate } from 'scenes/Affiliates/data';
import {
  useUpdateAffiliate,
  useCreateAffiliate,
} from 'scenes/Affiliates/data/mutations';

import AffiliateForm from './AffiliateForm';
import { OWNER, NAME, BUSINESS_PARTNER } from './constants';

export const AffiliateFormCreate = ({
  businessPartner,
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const formRef = useRef(null);
  const user = useCurrentUser();

  const [createAffiliate, { isLoading }] = useCreateAffiliate();

  const handleSubmit = async (values = {}) => {
    const createdAffiliate = await createAffiliate(values);

    onSubmit(createdAffiliate);
  };

  return (
    <AffiliateForm
      title={'Add Affiliate'}
      loading={isLoading}
      onClose={onClose}
      initialValues={{
        [OWNER]: user.id,
        [BUSINESS_PARTNER]: businessPartner,
      }}
      onSubmit={handleSubmit}
      isShowPartnerAffiliate={true}
      ref={formRef}
      onExited={onExited}
      open={open}
    />
  );
};

export const AffiliateFormEdit = ({
  id,
  onClose,
  onSubmit,
  onExited,
  open,
}) => {
  const formRef = useRef(null);

  const { data, isLoading: loading } = useLoadAffiliate(id);
  const [updateAffiliate, { isLoading: updating }] = useUpdateAffiliate();

  const handleSubmit = async (values) => {
    const response = await updateAffiliate(values);
    onSubmit(response);
  };

  return (
    <AffiliateForm
      title={'Edit Affiliate'}
      subTitle={data?.[NAME]}
      entityId={id}
      loading={loading || updating}
      onClose={onClose}
      initialValues={data}
      active={!!data}
      onSubmit={handleSubmit}
      isShowPartnerAffiliate={false}
      isEdit={true}
      ref={formRef}
      onExited={onExited}
      open={open}
    />
  );
};
